// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".global-search-dropdown-open .header-desktop__wrapper .header-desktop__globalsearch{width:480px}", ""]);
// Exports
module.exports = exports;
